module.exports = __webpack_public_path__ + "img/swiper1.b648c925.png";